import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';

declare var ko: any;

export class flightTrackerPagesList_template extends vnTemplate {

    public static YES_OR_NO = [
        {id: 1, name: "Yes"},
        {id: 0, name: "No"}
    ];

    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filter: filterSimple_template;
    protected indexedFilter: multipleSelector_template;

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.indexedFilter = new multipleSelector_template("indexedFilter", this.getTemplateViewModel(), this.caller);
        this.indexedFilter.setLabel('Indexed');
        this.indexedFilter.setFilterContainerClass('margin-neg');
        this.indexedFilter.setTagContainerId('selected-indexed');
        this.indexedFilter.setTagContainerCaption('Selected Indexed:');
        this.indexedFilter.setItems(flightTrackerPagesList_template.YES_OR_NO);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                indexed: this.getTemplateViewModel().indexedFilter.selectedItems
            }
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            flightTrackerPages: ko.observableArray([]),
            orderBy: ko.observable("weeklyPageviews"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("weeklyPageviews_DESC"),
            defaultThreshold: ko.observable(100),
            pageToDelete: ko.observable(null),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewPage: (data, event) => {
                self.viewPage(data.id, event);
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp: (data, event) => {
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp: (data, event) => {
                self.onClickHidePopUp()
            },
            onClickDelete: (data, event) => {
                self.onClickDelete()
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
        <div class="sub-header w-justify">
            <div class="w-left">
                ${this.indexedFilter.getHtmlBuild()}
            </div>
        </div>

        <div class="w-filters-selected">
            <div id="filters-selected" class="filters-selected">
                <div id="selected-indexed"></div>
            </div>
        </div>

        <div class="list-header w-justify">
            <div class="w-left">
                <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add a flight tracker page</button>
            </div>
            <div class="w-center">${this.filter.getHtmlBuild()}</div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>

        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'slug') }, css: { 'list-sort-desc': orderByAndDirection()=='slug_DESC', 'list-sort-asc': orderByAndDirection()=='slug_ASC' }">Slug</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'weeklyPageviews') }, css: { 'list-sort-desc': orderByAndDirection()=='weeklyPageviews_DESC', 'list-sort-asc': orderByAndDirection()=='weeklyPageviews_ASC' }">Weekly Views</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'indexOverride') }, css: { 'list-sort-desc': orderByAndDirection()=='indexOverride_DESC', 'list-sort-asc': orderByAndDirection()=='indexOverride_ASC' }">Override</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'indexed') }, css: { 'list-sort-desc': orderByAndDirection()=='indexed_DESC', 'list-sort-asc': orderByAndDirection()=='indexed_ASC' }">Indexed</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastSyncedAt') }, css: { 'list-sort-desc': orderByAndDirection()=='lastSyncedAt_DESC', 'list-sort-asc': orderByAndDirection()=='lastSyncedAt_ASC' }">Last Synced</span></th>
                            <th class="align-right"><span>Delete</span></th>
                        </tr>
                    </thead>

                    <tbody data-bind="foreach: flightTrackerPages">
                        <tr class="cursor">
                            <td data-bind="if: slug, event: { click: $parent.viewPage }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex">
                                        <span data-bind="text: permalink"></span>
                                        <button type="button" data-bind="event: { click: $parent.viewOnWebsite }" class="btn icon border only-icon i-link"/>
                                    </div>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: type"></span></a></td>
                            <td data-bind="if: name, event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: weeklyPageviews"></span></a></td>
                            <td data-bind="event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: indexOverride"></span></a></td>
                            <td data-bind="event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: indexed ? 'Yes' : 'No', css: indexed ? 'tag-positive' : 'tag-negative'"></span></a></td>
                            <td data-bind="event: { click: $parent.viewPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: lastSyncedAt ? lastSyncedAt.substring(0, 16) : '—'"></span></a></td>
                            <td data-bind="event: { click: $parent.viewPage }" class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting flight tracker page</h3>
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this flight tracker page:
                                    <p data-bind="if: pageToDelete() !== null">
                                       <span data-bind="text: pageToDelete().permalink"></span>
                                    </p>
                                </p>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "flightTrackerPagesList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewPage(data, event): any {
        this.caller.viewPage(data)
    }

    protected onClickReorder(value, data, event): any {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.flightTrackerPagesListReorder();
    }

    private viewOnWebsite(value) {
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink);
    }

    onClickAdd(): any {
        this.caller.addPage()
    }

    onClickDelete() {
        let page = this.getTemplateViewModel().pageToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deletePage(page);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().pageToDelete(null);
        this.toggleDeleteDialogVisibility()
    }

    onClickShowPopUp(data): any {
        this.getTemplateViewModel().pageToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    protected setFlightTrackerPages(pages, brandId) {
        pages.forEach((p) => p['emakiView'] = '/brand/' + brandId + '/config/flight-tracker-pages/edit/' + p.id + '/');
        this.getTemplateViewModel().flightTrackerPages(pages)
    }

    public setDefaultThreshold(threshold) {
        this.getTemplateViewModel().defaultThreshold(threshold);
    }

    public toggleDeleteDialogVisibility() {
        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/flightTrackerPagesList_template.ts